

class HeaderLink extends HTMLElement {
  tabLink; offcanvas;
  static classes = {
    active: 'active'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.tabLink = document.querySelector(this.dataset.tab);
    this.offcanvas = document.querySelector(this.dataset.bsTarget);

    this.addEventListener('mouseover', () => {
      this.open();
    });
  }

  open = () => {
    this.tabLink.show();
    this.show();

    if(this.offcanvas != undefined && !this.offcanvas.classList.contains('show')){
      const offcanvas = bootstrap.Offcanvas.getInstance(this.offcanvas) || new bootstrap.Offcanvas(this.offcanvas);
      offcanvas.show();
    }
  }

  show = () => {
    document.querySelectorAll('header-link').forEach((link) => {
      link.hide();
    });
    this.classList.add(HeaderLink.classes.active);
  }

  hide = () => {
    this.classList.remove(HeaderLink.classes.active);
  }
}
if (!window.customElements.get("header-link")) {
  window.customElements.define("header-link", HeaderLink);
}

class HeaderMobileTab extends HTMLElement {
  static classes = {
    active: 'active'
  }

  constructor() {
    super();
  }

  show = () => {
    this.classList.add(HeaderMobileTab.classes.active);
  }

  hide = () => {
    this.classList.remove(HeaderMobileTab.classes.active);
  }
}
if (!window.customElements.get("header-mobile-tab")) {
  window.customElements.define("header-mobile-tab", HeaderMobileTab);
}

class HeaderMobileLink extends HTMLElement {
  target;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.target = document.querySelector(this.dataset.tab) || document.querySelector(this.dataset.close);

    if(this.target != undefined && this.target.tagName == 'HEADER-MOBILE-TAB'){
      this.addEventListener('click', () => {
        if(this.dataset.close != undefined)
          this.target.hide();
        else
          this.target.show();
      });
    }
  }

  hide = () => {
    this.classList.remove(HeaderMobileTab.classes.active);
  }
}
if (!window.customElements.get("header-mobile-link")) {
  window.customElements.define("header-mobile-link", HeaderMobileLink);
}

class HeaderSearchResults extends HTMLElement {
  input;
  static classes = {
    hide: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.input = document.querySelector(this.dataset.searchBar);

    this.input.addEventListener('input', (e) => {
      this.search(e.target.value);
    });
  }

  search = (terms) => {
    if(terms.length < 3){
      this.classList.add(HeaderSearchResults.classes.hide);
    } else {
      axios.get(`${window.Shopify.routes.root}search/suggest?section_id=render-search&q=${terms}&resources[type]=query,${this.dataset.searchTypes}`)
      .then((response) => {
        this.innerHTML = response.data;
        this.classList.remove(HeaderSearchResults.classes.hide);
        window.dispatchEvent(new CustomEvent(Utils.E_SEARCH_RESULT, { detail: { terms: terms, results: this.querySelectorAll('search-result') } }));
      });
    }
  }
  
} 
if (!window.customElements.get("header-search-results")) {
  window.customElements.define("header-search-results", HeaderSearchResults);
}

class SideDesktop extends HTMLElement {
  
  constructor() {
    super();
  }
  

}

if (!window.customElements.get("side-desktop")) {
  window.customElements.define("side-desktop", SideDesktop);
}

class SideTab extends HTMLElement {
  static classes = {
    active: 'd-block',
    hidden: 'd-none'
  }

  constructor() {
    super();
  }

  show = () => {
    document.querySelectorAll('side-tab').forEach((tab) => {
      tab.hide();
    });
    this.classList.add(SideTab.classes.active);
    this.classList.remove(SideTab.classes.hidden);
  }

  hide = () => {
    this.classList.remove(SideTab.classes.active);
    this.classList.add(SideTab.classes.hidden);
  }
}
if (!window.customElements.get("side-tab")) {
  window.customElements.define("side-tab", SideTab);
}

class AnnouncementsBar extends HTMLElement {
  static classes = {
    hidden: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    console.log('AnnouncementsBar initialized colonna');

    const delay = this.dataset.delay || 5000; // Default to 5000ms if not specified

    document.addEventListener("DOMContentLoaded", function () {
      const messages = document.querySelectorAll('.announcement-message');
      let index = 0;

      setInterval(() => {
        messages[index].classList.remove('active');
        index = (index + 1) % messages.length;
        messages[index].classList.add('active');
      },  delay);
    });

  }

}
if (!window.customElements.get("announcements-bar")) {
  window.customElements.define("announcements-bar", AnnouncementsBar);
}